import * as Sentry from '@sentry/nextjs'
import { createEffect, sample } from 'effector'

import type { PortalProfile } from '@portal/portal-api'

import { $portalProfile } from '@/entities/profile/portal'

const sentrySetUserFx = createEffect((profile: PortalProfile | null) => {
    if (profile === null) {
        Sentry.setUser(null)
        return
    }

    Sentry.setUser({
        id: profile.publicId,
    })
})

sample({
    clock: $portalProfile,
    target: sentrySetUserFx,
})
